import React from "react";
import { useState,useContext } from "react";
//import accounticon from '../../assets/images/accounticon.png';
import englishright from '../../assets/images/englishright.png';
import { CustomerData } from "../utils/customers/CustomerData";
import API from '../../api/client';
import * as ENDPOINTS from '../../api/endpoints';
import {LoaderContext} from '../utils/Contexts';
import * as Config from '../../config/config';
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';

function Accountform() {
const { t } = useTranslation();
const customer = CustomerData.getCustomer();
const { isLoader, setLoader } = useContext(LoaderContext);
const [formData, setFormData] = useState({
    _id: customer._id,
    name: customer.name,
    email: customer.email,
    contactperson: customer.person_incharge,
    mobilecontact: customer.phone,
    officecontact: customer.office_number,
    email1: "",
    email2: "",
    companyname: customer.parent_company,
    companyaddress: customer.billing_address,
    deliveryaddress: customer.address,
    deliveryaddress1: customer.address2,
    deliveryaddress2: customer.address3,
    branchname: customer.company,
    subscribefornews: false,
  });
  const [errors, setErrors] = useState({});
  const [activeLanguage, setActiveLanguage] = useState(i18n.language); // Track the active language
  //const [chosenLang,setChosenLang]=useState(i18n.language);
  //console.log(i18n.language,'lang');
  
 // Validation Function
 const validateForm = () => {
  const newErrors = {};

  if (!formData.contactperson.trim()) {
    newErrors.contactperson = "Contact person is required.";
  }
  if (!formData.mobilecontact.trim()) {
    newErrors.mobilecontact = "Mobile contact is required.";
  } else if (!/^\d{10}$/.test(formData.mobilecontact)) {
    newErrors.mobilecontact = "Mobile contact must be a 10-digit number.";
  }
  if (!formData.officecontact.trim()) {
    newErrors.officecontact = "Office contact is required.";
  }
  if (!formData.companyaddress.trim()) {
    newErrors.companyaddress = "Company address is required.";
  }
  if (!formData.deliveryaddress.trim()) {
    newErrors.deliveryaddress = "Delivery address is required.";
  }
  // if (!formData.branchname.trim()) {
  //   newErrors.branchname = "Branch name is required.";
  // }

  setErrors(newErrors);

  // Return true if no errors
  return Object.keys(newErrors).length === 0;
};

const changeLanguage = (lang) => {
  i18n.changeLanguage(lang); // Change language
  localStorage.setItem('appLanguage', lang);
  setActiveLanguage(lang); // Set the active language
};

const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value, // Handle checkbox
  }));
};

  const handleSubmit = async(e) =>{
    e.preventDefault(); // Prevent page reload
    setLoader(true);
     // Validate form
     if (!validateForm()) {
      return; // Stop submission if validation fails
    }
    const response = await API.putWithToken(ENDPOINTS.SAVE_ACCOUNT,formData);
    
        if(response.statusText === 'OK') {
          setLoader(false);
          localStorage.setItem(Config.CUSTOMER_DATA_KEY, JSON.stringify(response.data.data.data));
          sessionStorage.setItem(Config.CUSTOMER_DATA_KEY, JSON.stringify(response.data.data.data));   
        }
  }

  return (

    <div className="heightscr- customscroll-">
                    <form className="formaccount" onSubmit={handleSubmit}>
                        <div className="fullsize">
                          <label>{t('contactperson')}</label>
                          <input className="textfield"
                            type="text"
                            id="contactperson"
                            name="contactperson"
                            value={formData.contactperson}
                            onChange={handleChange}
                            readOnly
                          />
                          {errors.contactperson && (
                            <p className="error-message">{errors.contactperson}</p>
                          )}
                        </div>
                        <div className="halfsize">
                          <p><label>{t('mobilecontact')}</label>
                          <input className="textfield"
                          type="tel"
                          id="mobilecontact"
                          name="mobilecontact"
                          value={formData.mobilecontact}
                          onChange={handleChange}
                          readOnly
                        />
                        {errors.mobilecontact && (
                          <p className="error-message">{errors.mobilecontact}</p>
                        )}
                        </p>
                        <p><label>{t('officecontact')}</label>
                          <input className="textfield"
                          type="tel"
                          id="officecontact"
                          name="officecontact"
                          value={formData.officecontact}
                          onChange={handleChange}
                          readOnly
                        />
                        {errors.officecontact && (
                        <p className="error-message">{errors.officecontact}</p>
                      )}
                         </p>
                        </div>
                        <div className="fullsize">
                          <label>{t('email')}</label>
                          <div className="sizesplit"><input className="textfield"
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          readOnly
                        /></div>
                        </div>
                        <div className="fullsize">
                          <label>{t('companyname')}</label>
                          <input className="textfield"
                            type="name"
                            id="companyname"
                            name="companyname"
                            value={formData.companyname}
                            onChange={handleChange}
                            readOnly
                          />
                        </div>
                        <div className="fullsize">
                          <label>{t('companyaddress')}</label>
                          <input className="textfield"
                            type="text"
                            id="companyaddress"
                            name="companyaddress"
                            value={formData.companyaddress}
                            onChange={handleChange}
                            readOnly
                          />
                          {errors.companyaddress && (
                          <p className="error-message">{errors.companyaddress}</p>
                        )}
                        </div>
                        <div className="fullsize">
                          <label>{t('deliveryaddress')}</label>
                          <input className="textfield"
                            type="text"
                            id="deliveryaddress"
                            name="deliveryaddress"
                            value={formData.deliveryaddress}
                            onChange={handleChange}
                            readOnly
                          />
                          {errors.deliveryaddress && (
                          <p className="error-message">{errors.deliveryaddress}</p>
                        )}
                        </div> 
                        {formData.deliveryaddress1 &&
                        (<div className="fullsize">
                          <label>{t('deliveryaddress1')}</label>
                          <input className="textfield"
                            type="text"
                            id="deliveryaddress1"
                            name="deliveryaddress1"
                            value={formData.deliveryaddress1}
                            onChange={handleChange}
                            readOnly
                          />
                          
                        </div> )}
                        {formData.deliveryaddress2 &&
                        (<div className="fullsize">
                          <label>{t('deliveryaddress2')}</label>
                          <input className="textfield"
                            type="text"
                            id="deliveryaddress2"
                            name="deliveryaddress2"
                            value={formData.deliveryaddress2}
                            onChange={handleChange}
                            readOnly
                          />
                          
                        </div>)} 
                         <div className="fullsize">
                          <label>{t('branchname')}</label>
                          <input className="textfield"
                            type="text"
                            id="branchname"
                            name="branchname"
                            value={formData.branchname}
                            onChange={handleChange}
                            readOnly
                          />
                        </div>
                       {/* <div className="checkbox-input">
                            <div className="checkbox-right">
                              <input
                          type="checkbox"
                          id="rememberMe"
                          name="rememberMe"
                          checked={formData.rememberMe}
                          onChange={handleChange}
                        />
                           <label htmlFor="subscribefornews">Receive the latest news in your inbox!</label> 
                          </div>
                        </div> */}
                        <div className="select_langugae">
                            <label>{t('selectedlang')}</label>
                            <div className="select_langugaediv">
            <div
              type="text"
              className={`engchi ${activeLanguage === 'en' ? 'active' : ''}`}
              onClick={() => changeLanguage('en')}
            >
              <img className="" src={englishright} alt="" width="47" height="47" />
              {t('english_txt')}
            </div>
            <div
              type="text"
              className={`engchi ${activeLanguage  === 'zh_CN' ? 'active' : ''}`}
              onClick={() => changeLanguage('zh_CN')}
            ><img className="" src={englishright} alt="" width="47" height="47" />
              {t('chinese_txt')}
            </div>
            {/* <button type="submit" className="save">{t('save_txt')}</button> */}
          </div>
                        </div> 
                      </form>
                  </div>

    );
}

export default Accountform;
